<template>
  <div>
    <div id="toolbar">
      <el-button-group>
        <el-button size="mini" icon="el-icon-plus" @click="$refs.chart.add(10, 10)">
          添加
        </el-button>
        <el-button size="mini" icon="el-icon-minus" @click="$refs.chart.remove()">
          删除
        </el-button>
        <el-button size="mini" icon="el-icon-edit-outline" @click="$refs.chart.editCurrent()">
          编辑
        </el-button>
        <el-button size="mini" icon="el-icon-check" @click="$refs.chart.save()">
          保存
        </el-button>
      </el-button-group>
<!--      <el-select v-model="versionValue" placeholder="请选择" style="display: none;">-->
<!--        <el-option-->
<!--            v-for="item in versionOptions"-->
<!--            :key="item.uuid"-->
<!--            :label="item.workflowVersion"-->
<!--            :value="item.uuid">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--      <el-button size="mini" @click="setFixCopy">设置固定通知人员</el-button>-->
    </div>
    <flow-chart v-if="nodes.length > 0" :width="chartWidth" :nodes="nodes" :connections="connections" locale="zh"
                @editnode="handleEditNode"
                @editconnection="handleEditConnection" @save="handleChartSave" ref="chart">
    </flow-chart>
    <el-drawer title="编辑节点" v-if="nodeDialogVisible" :visible.sync="nodeDialogVisible" size="550px" direction="rtl">
      <flow-chart-node-dialog v-if="updataChart" :approver-form="approverForm" :nodes="nodes"></flow-chart-node-dialog>
      <div class="dialog-footer">
        <el-button @click="nodeDialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleClickSaveApprover">确 定</el-button>
      </div>
    </el-drawer>
    <el-drawer title="编辑条件" v-if="connectionDialogVisible" :visible.sync="connectionDialogVisible" size="550px"
               direction="rtl">
      <flow-chart-connection-dialog :transition="transition"
                                    @onchangebranch="onChangeBranch"
                                    @onclosebranchvisible="onCloseBranchVisible">
      </flow-chart-connection-dialog>
    </el-drawer>
    <el-drawer title="流转条件详情" v-if="sqlDialogVisible" :visible.sync="sqlDialogVisible" size="550px" direction="rtl">
      <div style="">
        <div class="title-box" style="border:none;">
          <span style="flex:0 0 40px;">sql</span>
          <input v-model="transition.title" type="text" class="itemInput" style="flex:1;">
        </div>
        <div class="title-box" style="border:none;">
          <span style="flex:0 0 40px;">描述</span>
          <input v-model="transition.defaultName" type="text" class="itemInput" style="flex:1;">
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {
  Message
} from "element-ui";
import FlowChart from 'flowchart-vue';
import FlowChartNodeDialog from '../components/NodeDialog';
import FlowChartConnectionDialog from '../components/ConnectionDialog';
import processService from "../service/flowChart/processService";
import _ from "lodash";

let Base64 = require('js-base64').Base64

export default {
  components: {
    FlowChartConnectionDialog, FlowChartNodeDialog, FlowChart,
  },
  data: function () {
    return {
      nodes: [],
      connections: [],
      editingInfo: {target: null},
      connectionEditingInfo: {target: null},
      nodeDialogVisible: false,
      connectionDialogVisible: false,
      sqlDialogVisible: false,
      approverForm: {},
      transition: {},
      dictionaries: {},
      chartWidth: 800,
      versionValue: "",
      versionOptions:[],
      updataChart: true
    };
  },
  async mounted() {
    this.chartWidth = document.body.offsetWidth - 575 > 800 ? document.body.offsetWidth - 575 : 800;
    // let versionResp = await processService.getVersion(this.$route.query.name);
    // if(versionResp.data.Status === "1") {
    //   this.versionOptions = versionResp.data.Data || [];
    //   if(versionResp.data.Data.length > 0) {
    //     this.versionValue = versionResp.data.Data[0].uuid;
    //   }
    // }
    let res = await processService.getDictionaries();
    if (res.data.Status === "1") {
      this.dictionaries = res.data.Data;
      this.dictionaries['部门'] = _.union(this.dictionaries['部门'], [
        {uuid: 0, name: '本部门'},
        {uuid: -1, name: '上级部门'},
        {uuid: -2, name: '表单部门'},
        {uuid: -3, name: '上个环节审核人所在部门'},
        {uuid: -4, name: '所在分公司'},
        {uuid: -5, name: '所在区域'}
      ]);
    }
    this.load();
  },
  watch: {
    nodes: {
      immediate: true,
      deep: true,
      handler() {
        this.updataChart = false;
        var _this = this;
        this.$nextTick(function () {
          _this.updataChart = true;
        })
      },
    },

  },
  methods: {
    async load() {
      let resp = await processService.getNodes(this.$route.query.id || 1);
      if (resp.data.Status === "1") {
        this.nodes = [];
        this.connections = [];
        let nodes = resp.data.Data.Nodes;
        if (nodes.length === 0) {
          let startNode = {id: 1, x: 140, y: 270, name: '开始', type: 'start'};
          let endNode = {id: 2, x: 540, y: 270, name: '结束', type: 'end'}
          this.nodes = [];
          this.nodes.push(startNode);
          this.nodes.push(endNode);
        } else {
          for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i];
            if (nodes[i].Conditions && nodes[i].Conditions.length > 0) {
              for (let j = 0; j < nodes[i].Conditions.length; j++) {
                var positions = nodes[i].Conditions[j].positions;
                let obj = {
                  type: 'pass',
                  destination: {
                    id: parseInt(nodes[i].Conditions[j].nextStepNode),
                    position: (positions ? positions.split('-')[1] : 'left')
                  },
                  source: {id: parseInt(nodes[i].nodeId), position: (positions ? positions.split('-')[0] : 'right')},
                  title: nodes[i].Conditions[j].conditions,
                  defaultName: nodes[i].Conditions[j].description,
                  uuid: nodes[i].uuid
                };
                if (nodes[i].Conditions[j].conditions) {
                  if (nodes[i].Conditions[j].conditions.indexOf("creatorId in ('") === 0) {
                    obj.defaultType = 4;
                    obj.defaultConditionjson = nodes[i].Conditions[j].conditions.split("creatorId in ('")[1].split("')")[0].split("','");
                  } else if (nodes[i].Conditions[j].conditions.indexOf("creatorId in (select staffId from ") === 0 && nodes[i].Conditions[j].conditions.indexOf("base_position_staff where positionId in ('") !== -1) {
                    obj.defaultType = 3;
                    obj.defaultConditionjson = nodes[i].Conditions[j].conditions.split("base_position_staff where positionId in ('")[1].split("'))")[0].split("','");
                  } else if (nodes[i].Conditions[j].conditions.indexOf("creatorId in (select leader from ") === 0 && nodes[i].Conditions[j].conditions.indexOf("base_department where uuid in (select departmentId from") !== -1) {
                    obj.defaultType = 1;
                  } else if (nodes[i].Conditions[j].conditions.indexOf("creatorId in (select uuid from ") === 0 && nodes[i].Conditions[j].conditions.indexOf("base_staff where departmentId in (") !== -1) {
                    obj.defaultType = 2;
                    obj.defaultConditionjson = nodes[i].Conditions[j].conditions.split("base_staff where departmentId in ('")[1].split("'))")[0].split("','");
                  } else {
                    obj.defaultType = 23;
                    if (nodes[i].Conditions[j].conditionJson) {
                      obj.defaultConditionjson = JSON.parse(nodes[i].Conditions[j].conditionJson).conditionJson;
                    }

                  }
                }
                this.connections.push(obj)
              }
            }
            if (!nodes[i].isEndNode && nodes[i].agreeNextNode && nodes[i].agreeNextNode !== '-3') {
              let agreeNextNodes = nodes[i].agreeNextNode.split(',');
              if (agreeNextNodes.length > 1) {
                for (let j = 0; j < agreeNextNodes.length; j++) {
                  var positions = nodes[i].positions ? nodes[i].positions.split(',')[j].split('-') : ['right', 'left'];
                  this.connections.push({
                    uuid: nodes[i].uuid,
                    title: '', type: 'pass',
                    destination: {id: parseInt(nodes[i].agreeNextNode.split(',')[j]), position: positions[1]},
                    source: {id: parseInt(nodes[i].nodeId), position: positions[0]}
                  })
                }
              } else {
                var positions = nodes[i].positions ? nodes[i].positions.split('-') : ['right', 'left'];
                this.connections.push({
                  uuid: nodes[i].uuid,
                  title: '', type: 'pass',
                  destination: {id: parseInt(nodes[i].agreeNextNode), position: positions[1]},
                  source: {id: parseInt(nodes[i].nodeId), position: positions[0]}
                })
              }
            }
            node.y = parseFloat(nodes[i].coordinate.split(',')[0]);
            node.x = parseFloat(nodes[i].coordinate.split(',')[1]);
            node.id = parseInt(nodes[i].nodeId);
            node.name = nodes[i].title;
            node.approverType = nodes[i].auditWay + '';
            node.copyType = nodes[i].copyType + '';
            node.uuid = nodes[i].uuid;
            node.workflowType = nodes[i].workflowType;
            if (!nodes[i].isEndNode && !nodes[i].isStartNode) {
              node.original = true;
            }
            if (nodes[i].auditDepartment) {
              node.approverDepartmentIds = nodes[i].auditDepartment.split(',');
            }
            if (nodes[i].auditorId) {
              node.approverIds = nodes[i].auditorId.split(',');
            }
            if (nodes[i].auditPosition) {
              node.approverRoleIds = nodes[i].auditPosition.split(',');
            }
            if (nodes[i].formField) {
              node.approverFormFieldIds = nodes[i].formField.split(',');
            }
            if (nodes[i].copyPerson) {
              node.copyIds = nodes[i].copyPerson.split(',');
            }
            if (nodes[i].copyPost) {
              node.copyRoleIds = nodes[i].copyPost.split(',');
            }
            if (nodes[i].copyDepartmentId) {
              node.copyDepartmentIds = nodes[i].copyDepartmentId.split(',');
            }
            if (nodes[i].copyField) {
              node.copyFormFieldIds = nodes[i].copyField.split(',');
            }
            if (nodes[i].noAuditorAutoSkip) {
              node.checked = nodes[i].noAuditorAutoSkip;
            }
            if (nodes[i].upSearching) {
              node.upQuery = nodes[i].upSearching;
            }
            if (nodes[i].canWriteCells) {
              node.txtEditableFields = nodes[i].canWriteCells.split(',');
            }
            if (nodes[i].hideCells) {
              node.txtInvisibleFields = nodes[i].hideCells.split(',');
            }
            if (nodes[i].disagreeNextProcess) {
              node.returnNodeId = nodes[i].disagreeNextProcess;
            }
            if (nodes[i].countersign) {
              node.mostApproverType = '2';
            }
            if (nodes[i].seriesCountersign) {
              node.mostApproverType = '3';
            }
            if (nodes[i].isStartNode) {
              node.type = 'start';
            } else if (nodes[i].isEndNode) {
              node.type = 'end';
            } else {
              node.type = 'operation';
            }
            switch (nodes[i].auditWay) {
              case 1:
                node.approvers = this.getTextFromDictionaries('员工', nodes[i]['auditorId']);
                break;
              case 2:
                node.approvers = this.getTextFromDictionaries('岗位', nodes[i]['auditPosition']);
                break;
              case 4:
                node.approvers = this.getTextFromDictionaries('部门', nodes[i]['auditDepartment']);
                break;
              case 5:
                node.approvers = this.getTextFromDictionaries('部门', nodes[i]['部门']) + '-' + this.getTextFromDictionaries('功能点', nodes[i]['功能点']);
              case 35:
                node.approvers = ['自由选择人员'];
            }

            if (node.approvers) {
              node.approvers = node.approvers.map(item => ({
                name: item
              }));
            }

            this.nodes.push(node)
          }

        }

      }
    },
    async saveNode(node) {
      let resp = await processService.saveNodes(node, this.$route.query.id);
      if (resp.data.Status == "1") {
        Message.success(resp.data.Data);
        this.load();
      }
    },
    async handleChartSave(nodes, connections) {
      console.log(nodes);
      console.log(connections);
      let data = nodes.map(node => {
        let result = {
          id: node.id,
          x: node.y || 0,
          y: node.x || 0,
          name: node.name || '审批节点',
          state: node.type,
          approvers: node.approvers,
          approverType: node.approverType,
          approverText: node.approverText,
          approverIds: node.approverIds,
          approverDepartmentIds: node.approverDepartmentIds,
          approverRoleIds: node.approverRoleIds,
          approverFormFieldIds: node.approverFormFieldIds,
          copyType: node.copyType,
          copyText: node.copyText,
          copyIds: node.copyIds,
          copyDepartmentIds: node.copyDepartmentIds,
          copyRoleIds: node.copyRoleIds,
          copyFormFieldIds: node.copyFormFieldIds,
          mostApproverType: node.mostApproverType || '',
          txtEditableFields: node.txtEditableFields,
          txtInvisibleFields: node.txtInvisibleFields,
          checked: node.checked,
          returnNodeId: node.returnNodeId,
          upQuery: node.upQuery,
          processDefinitionId: this.$route.query.id,
          uuid: node.uuid,
          clientId: node.id
        };
        result.transitions = connections.filter(conn => conn.source.id === node.id).map(conn => {
          return {
            source: conn.source.id,
            destination: conn.destination.id,
            positions: conn.source.position + "-" + conn.destination.position,
            conditionJson: conn.defaultConditionjson || [],
            type: conn.defaultType,
            description: conn.defaultName,
          };
        });
        return result;
      });
      this.saveNode(data)
    },
    handleEditNode(node) {
      console.log(node)
      this.editingInfo.target = node;
      this.approverForm = Object.assign({}, node)
      this.nodeDialogVisible = true;
    },
    handleEditConnection(connection) {
      this.connectionEditingInfo.target = connection;
      this.transition = Object.assign({}, connection)
      //this.initFormByGraphType(this.transition);
      if (connection.defaultType && connection.defaultType == '23') {
        this.sqlDialogVisible = true;
      } else {
        this.connectionDialogVisible = true;
      }
    },
    handleClickSaveApprover() {
      this.nodeDialogVisible = false;
      if (this.approverForm.approverText) {
        this.approverForm.approvers = this.approverForm.approverText.split(',').map(item => ({
          name: item
        }));
      }
      Object.assign(this.editingInfo.target, this.approverForm);
    },
    onChangeBranch(obj) {
      this.transition.defaultType = obj.conditionType;
      this.transition.defaultName = obj.name;
      this.transition.defaultDescription = obj.description;
      this.transition.defaultConditionjson = obj.conditionJson;
      this.transition.title = obj.title;
      Object.assign(this.connectionEditingInfo.target, this.transition);
      this.connectionDialogVisible = false;
    },
    onCloseBranchVisible() {
      this.connectionDialogVisible = false;
    },
    getTextFromDictionaries(dictName, value) {
      if (!value) return '无';
      var values = value.split(',');
      var result = '';
      for (let i = 0; i < this.dictionaries[dictName].length; i++) {
        for (let j = 0; j < values.length; j++) {
          if (this.dictionaries[dictName][i]['uuid'] == values[j]) {
            if (result.length > 0) result += ',';
            result += this.dictionaries[dictName][i]['name'];
          }
        }
      }
      return result.split(',');
    },
  },
};
</script>
<style>
#toolbar {
  margin-bottom: 10px;
}
</style>